// extracted by mini-css-extract-plugin
export default {"finalDateWrapper":"FinalDateCountdown_finalDateWrapper__ACVUG","finalDateText":"FinalDateCountdown_finalDateText__eM+6d"};